import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DoughnutChart from "./chart"
import { View_Answer } from '../redux/authslice';
import { Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const QuizModal = ({ show, handleClose, QuizzData, currentQuestionIndex, viewData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleview = () => {
        const q_id = localStorage.getItem("id");
        if (q_id) {
            dispatch(View_Answer({ id: q_id, navigate, dispatch }));
        }
        handleClose();
        navigate("/quizz");
    }

    return (
        <Modal show={show}
            onHide={handleClose}
            centered size="md"
            backdrop="static"
            keyboard={false}
            dialogClassName="custom-modal">
            <Modal.Header closeButton style={{ border: "none" }}></Modal.Header>
            {/* <div style={{ height: "70px", width: "100%", marginBottom: '20px' }}>
                <DoughnutChart QuizzData={QuizzData} currentQuestionIndex={QuizzData?.length - QuizzData?.length - 1} />
            </div> */}
            <Modal.Title id="example-modal-sizes-title-sm"
                style={{
                    textAlign: 'center',
                    fontSize: "20px",
                    color: "#62636C",
                    fontWeight: "600"
                }}>
                Congratulations on successfully completing this quiz!
            </Modal.Title>
            <Modal.Body
                style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    fontSize: "13px",
                    color: "#62636C"
                }}>
                Your quiz has been submitted successfully
            </Modal.Body>
            <Modal.Footer style={{ border: "none", display: "flex", justifyContent: "center" }}>
                <Button variant="secondary" className='set_btn' onClick={handleview} size='sm'>
                    View answers
                </Button>
                <Button variant="secondary" className='set_btn' onClick={handleClose} size='sm'>
                    Generate quiz
                </Button>
            </Modal.Footer>
        </Modal>
    )
};
export default QuizModal;
